<template>
        <b-form-group
            :invalid-feedback="error"
            :label="label"
            :label-for="config.name">
            <small v-if="config.description" class="form-text mb-2">{{ _.get(config, 'description') }}</small>
            <template v-if="!disabled">
                <custom-select-component
                    v-on:input="onInput"
                    v-on:change="onChange"
                    :disabled="disabled"
                    :value="_.get(currentValue, 'id', null)"
                    :placeholder="required ? 'Please select an option' : '-- None --'"
                    :options="options"
                    ></custom-select-component>
            </template>
            <input v-else type="text" class="form-control" disabled :value="_.get(currentValue, 'name')"></input>
        </b-form-group>
</template>
<script>
import Vue from 'vue';
import V from 'voca';
import CustomSelectComponent from '../helpers/CustomSelectComponent';

export default {
    data () {
        return {
            initialized: false,
            link: null,
            values: [],
        }
    },

    props: ['value', 'label', 'required', 'config', 'data', 'state', 'error'],

    components: {
        CustomSelectComponent,
    },

    mounted() {
        if (this.config.values) {
            this.values = this.config.values;
            this.initialized = true;
            return;
        }

        const api = this.helpers('api');
        let link = _.get(this.config, 'link', []);

        if (_.isArray(link)) {
            // do nothing
        } else {
            link = [link];
        }

        Promise.all(_.chain(link)
            .map(url => api.getData(url))
            .value()
        )
            .then(responses => {
                const data = _.chain(responses).flatMap(res => {
                    const type = _.get(res, 'type');
                    return _.get(res, 'data', [])
                        .map(item => ({ ...item, id: this.multiple ? `${type}/${item.id}` : item.id }))
                }).value();

                this.values = data;
                this.initialized = true;
            })
    },

    computed: {
        options() {
            let options = _.chain(this.values)
                .map(item => {
                    const id = item.id;
                    const name = item.fullname || item.name || _.get(item, 'attributes.name');
                    return { id, name }
                })
                .value();

            if (this.isParentRelationship) {
                // build up sub hierarchy of current model
                let hierarchy = [_.get(this.data, 'id')];
                let values = _.values(this.values);
                let process = true;

                while(process) {
                    let newValues = [];
                    process = false;
                    values.forEach((item, idx) => {
                        if (item.parent_id && hierarchy.indexOf(item.parent_id) >= 0) {
                            hierarchy.push(item.id);
                            process = true;
                        } else {
                            newValues.push(item);
                        }
                    })
                    values = newValues;
                }

                options = _.filter(options, option => hierarchy.indexOf(option.id) < 0);
            }

            options = _.sortBy(options, _.get(this.config, 'sortBy', ['name']))

            if (!this.required) {
                options.unshift({ id: null, name: '-- None --' });
            }

            return options;
        },

        currentValue() {
            let id = _.isObject(this.value) ? this.value.id : this.value;

            return this.values.find(value => value.id == id);
        },

        isParentRelationship() {
            return _.get(this.config, 'relationship') == 'parent';
        },

        multiple() {
            return _.get(this.config, 'multiple', false);
        },

        disabled() {
            return _.get(this.config, 'readonly', false);
        },
    },

    methods: {
        onInput(newValue) {
            const value = this.values.find(value => value.id == newValue) || null;
            let id = _.get(value, 'id');

            if (!this.multiple) {
                id = _.chain(id).split('/').last().value();
            }

            this.$emit('input', id);
            this.$emit('change', { ...value, id });
        },

        onChange(newValue) {

        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/LazyLoadingSelectComponent.vue